import "./index.scss";
import { Bounce } from "react-awesome-reveal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSpeakerDeck, faSuperpowers, faYoutube } from "@fortawesome/free-brands-svg-icons";
import {
  faChildren,
  faCogs,
  faFile,
  faLock,
  faMoneyCheckDollar,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

const SectionWhy = () => {
  return (
    <div className="section-why">
      <div className="header" align="center">
        <div className="header-content">
          <Bounce cascade>
            <h1 className="title-text">Why MygradeCard</h1>
          </Bounce>
        </div>
      </div>

      <div className="w3-container">
        <div className="w3-row">
          <div className="w3-third">
            <div className="card">
              <div className="card-icon">
                <FontAwesomeIcon
                  icon={faMoneyCheckDollar}
                  className="icon"
                  size="lg"
                />
              </div>
              <div className="card-header">
                <h3>Finance</h3>
              </div>
              <div className="card-content">
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
              </div>
            </div>
          </div>

          <div className="w3-third">
            <div className="card">
              <div className="card-icon">
                <FontAwesomeIcon icon={faFile} className="icon" size="lg" />
              </div>
              <div className="card-header">
                <h3>Result</h3>
              </div>
              <div className="card-content">
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
              </div>
            </div>
          </div>

          <div className="w3-third">
            <div className="card">
              <div className="card-icon">
                <FontAwesomeIcon icon={faLock} className="icon" size="lg" />
              </div>
              <div className="card-header">
                <h3>Data Protection</h3>
              </div>
              <div className="card-content">
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w3-row">
          <div className="w3-third">
            <div className="card">
              <div className="card-icon">
                <FontAwesomeIcon icon={faCogs} className="icon" size="lg" />
              </div>
              <div className="card-header">
                <h3>Tools</h3>
              </div>
              <div className="card-content">
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
              </div>
            </div>
          </div>

          <div className="w3-third">
            <div className="card">
              <div className="card-icon">
                <FontAwesomeIcon icon={faChildren} className="icon" size="lg" />
              </div>
              <div className="card-header">
                <h3>Student Administration</h3>
              </div>
              <div className="card-content">
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
              </div>
            </div>
          </div>

          <div className="w3-third">
            <div className="card">
              <div className="card-icon">
                <FontAwesomeIcon icon={faUsers} className="icon" size="lg" />
              </div>
              <div className="card-header">
                <h3>Parent Collaboration</h3>
              </div>
              <div className="card-content">
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionWhy;
